import {useState, useEffect} from "react";
import {withTranslation} from "react-i18next";
import "../../ceiba.scss";
import {Button, Progress, Spin} from 'antd';
import {CheckCircleOutlined} from "@ant-design/icons";
import {history} from "../../../../../_helpers";
import {xcService} from "../../../../../_services/xcService";
import endpoint from "shared/endpoints";

function MiDiploma(props) {

    const {t} = props;
    const [answers, setAnswers] = useState([]);
    const [questions, setQuestions] = useState(-1);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            const responseA = await xcService.getToken(endpoint.studentAnswer.getAll('XCELENCE'));
            setAnswers(responseA.data.data)

            const responseQ = await xcService.getToken("/v1/student/assessments/XCELENCE");
            setQuestions(responseQ.data.data?.length)
            setLoading(false)

        } catch (e) {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData();


    }, []);


    const goTo = () => {
        if (questions === answers)
            history.push("/admin/end-xcelence")
        else
            history.push("/admin/xcelence")
    }

    return (


        <div className={"selectQ diploma"}>

            {!loading ?
                <>
                <div className={"wrapper"}>
                    <div>
                        <p>{t("world.stepdiploma")}</p>
                        <h2>{t("world.diploma")}</h2>
                    </div>
                    <h3>{t("world.descdiploma")}</h3>
                    <Button  onClick={() => goTo()}
                             type={"primary"}
                             className="buttonSizeXM btnBorder"
                    >
                        {t("enter")}
                    </Button>
                    {/* ToDo: Revisar el correcto funcionamiento*/}
                    { questions === answers.length ?
                      <div className={"posend"}>
                          <CheckCircleOutlined style={{ fontSize: 40}} />
                      </div> :
                      questions !== -1 ?
                        <div className={"posend"}>
                            <Progress width={50} type="circle" percent={ ((answers.length * 100) / (questions)) } format={() => ""} />
                        </div>
                        :
                        <div className={"posend"}></div>
                    }
                </div>
                <Button  onClick={() => goTo()}
                         type={"primary"}
                         className=" btnBorder is-mobile-wh"
                >
                    {t("world.mxcelence")}
                </Button>
                </> : <Spin />}

        </div>
    )
}

export default withTranslation()(MiDiploma);
